import styled from "styled-components";

// styles
import breakpoints from "core/breakpoints";
import Avatar from "core/Avatar";
import { easingSeconds } from "core/animation";
import { convertPxToRem } from "frontend/components/helpers";

// styled-components
export const AvatarContainer = styled.div`
    position: relative;
    margin-right: ${convertPxToRem({ px: 16 })};
`;

export const AvatarLinkStyled = styled.a`
    ${AvatarStyled} {
        opacity: 1;
        transition: all ${easingSeconds};
    }

    &:hover {
        ${AvatarStyled} {
            opacity: 0.6;
        }
    }
`;

export const AvatarStyled = styled(Avatar)`
    /* Custom breakpoint for this view */
    @media (min-width: 60rem) and (max-width: ${breakpoints.beforeDesktop
            .rem}) {
        height: 2.188rem; /* 35px */
        width: 2.188rem; /* 35px */
    }
`;
